import { createSlice } from '@reduxjs/toolkit';

const getInitialDarkModeState = () => {
  const savedDarkMode = localStorage.getItem('isDarkMode');
  return savedDarkMode ? JSON.parse(savedDarkMode) : false;
};

const initialState = {
  isDarkMode: getInitialDarkModeState(), 
};

const darkModeSlice = createSlice({
  name: 'darkMode',
  initialState,
  reducers: {
    toggleDarkMode: (state) => {
      state.isDarkMode = !state.isDarkMode; 
      localStorage.setItem('isDarkMode', JSON.stringify(state.isDarkMode))
    },
  },
});

export const { toggleDarkMode } = darkModeSlice.actions;

export default darkModeSlice.reducer;